import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "append-month-text"
};
const _hoisted_2 = {
  class: "contract-list-btn"
};
const _hoisted_3 = {
  class: "contract-select-wrapper"
};
const _hoisted_4 = {
  class: "contract-filter-area"
};
const _hoisted_5 = {
  class: "contract-table-area"
};
const _hoisted_6 = {
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_7 = {
  class: "dialog-footer"
};
import { reactive, ref, nextTick, computed } from "vue";
import dayjs from "dayjs";
import apis from "@/api";
import { ElMessage } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import { USERINFO } from "@/store/mutation-types";
import MoreUpload from '@/components/MoreUpload.vue';
import { getFileEndPoint } from "@/api/modules/system";

// 获取当前登录用户信息

export default {
  __name: 'ContractSelect',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userRole: {
      type: Object
    },
    /** add：添加计提任务（可选月、模板、时效）；append：继续添加合同（月固定且只读，不展示模板与时效） */
    selectType: {
      type: String,
      default: 'add',
      validator: v => ['add', 'append'].includes(v)
    },
    /** 继续添加合同时由列表行传入：month、endDate、accrueProofTemplateUrls */
    appendPreset: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'commit'],
  setup(__props, {
    emit: __emit
  }) {
    const getCurrentUserId = () => {
      try {
        const userInfo = JSON.parse(window.localStorage.getItem(USERINFO));
        return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) || '';
      } catch (e) {
        return '';
      }
    };
    const currentUserId = getCurrentUserId();
    const contractTypeMap = {
      0: '广告投放',
      1: '活动宣传',
      2: '媒介监测'
    };
    const emit = __emit;
    const props = __props;
    const isAddMode = computed(() => props.selectType === 'add');
    const dialogTitle = computed(() => isAddMode.value ? '添加计提任务' : '继续添加合同');
    const data = reactive({
      queryParam: {
        contractCode: '',
        contractName: '',
        supplier: '',
        validDate: dayjs().format('YYYY-MM-DD')
      },
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 20,
        pageNo: 1
      },
      loading: false
    });
    const form = reactive({
      date: dayjs().format("YYYY-MM"),
      endDate: dayjs().add(1, 'month').format("YYYY-MM-DD"),
      accrueProofTemplateUrls: '',
      contractCodes: new Set(),
      // 使用Set结构管理选中的合同code
      selectMap: new Map(),
      // 存储合同code和contract的映射关系
      contractRows: [] // 计提任务行列表，支持同一合同多行
    });
    const selectData = reactive({
      selectShow: false
    });
    const proofTemplateDialog = reactive({
      visible: false,
      fileList: [],
      uploadVisible: false
    });

    // 表格引用
    const tableRef = ref(null);
    const close = () => {
      emit('update:visible', false);
    };
    const loadData = () => {
      const params = {
        ...data.queryParam,
        ...data.pagination
      };
      if (!props.userRole) {
        return;
      }
      // 只能添加自己地区下的合同
      params.areaCodeList = props.userRole.areaCode;
      params.valid = '1';
      // 只能查询当前登录人创建的合同
      params.createBy = currentUserId;
      data.loading = true;
      apis.getContractList(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
          // 数据加载完成后，根据列表回显选中状态
          nextTick(() => {
            setTableSelection();
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        data.loading = false;
      });
    };
    const handleCommit = () => {
      if (form.contractCodes.size === 0) {
        ElMessage.error('请选择至少一个合同');
        return;
      }
      const commitForm = {
        contractInfoList: form.contractRows,
        month: form.date,
        areaCode: props.userRole.areaCode,
        accrueProofTemplateUrls: form.accrueProofTemplateUrls,
        endDate: form.endDate
      };
      apis.addAccrue(commitForm).then(res => {
        if (res.success) {
          ElMessage.success('提交成功');
          close();
          emit('commit');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleSearch = () => {
      data.pagination.pageNo = 1;
      loadData();
    };
    const handleReset = () => {
      data.queryParam = {
        contractCode: '',
        contractName: '',
        supplier: '',
        validDate: dayjs().format('YYYY-MM-DD')
      };
      handleSearch();
    };
    // 根据contractCodes设置表格选中状态
    const setTableSelection = () => {
      if (!tableRef.value || !data.tableData.length) {
        return;
      }
      // 先清除所有选中
      tableRef.value.clearSelection();
      // 遍历当前页数据，如果code在contractCodes中，则选中
      data.tableData.forEach(row => {
        if (form.contractCodes.has(row.contractCode)) {
          tableRef.value.toggleRowSelection(row, true);
        }
      });
    };

    // 联系人缓存：按供应商维度缓存，避免重复请求
    const contractCache = new Map();

    // 为单条合同加载供应商联系人，并根据已有选择或默认规则绑定
    // force 表示是否强制从当前行/缓存重新初始化（用于上月自动带入场景）
    const loadContractForRow = (row, force = false) => {
      if (!row || !row.supplierId) {
        return;
      }

      // 非强制情况下，当前行已经有联系人列表则不再处理
      if (!force && row.contractUserList && row.contractUserList.length) {
        return;
      }
      const applyListToRow = list => {
        if (!list.length) {
          return;
        }
        row.contractUserList = list;
        // 如果已经有手机号，则按手机号回显对应联系人
        if (row.contractUserMobile) {
          const existed = list.find(item => item.mobile === row.contractUserMobile);
          if (existed) {
            row.contractUserId = existed.userId;
            row.contractUserName = existed.name;
            row.contractUserMobile = existed.mobile;
            // 强制触发表格/下拉框的更新，避免首次进入时选不中的问题
            form.contractRows = [...form.contractRows];
            return;
          }
        }
        // 否则默认选中第一个
        const first = list[0];
        row.contractUserId = first.userId;
        row.contractUserName = first.name;
        row.contractUserMobile = first.mobile;
        // 强制触发表格/下拉框的更新，避免首次进入时选不中的问题
        form.contractRows = [...form.contractRows];
      };

      // 命中缓存
      if (contractCache.has(row.supplierId)) {
        const list = contractCache.get(row.supplierId) || [];
        applyListToRow(list);
        return;
      }

      // 未命中缓存，请求接口并写入缓存
      apis.getRolesUserList(row.supplierId).then(res => {
        if (res.success) {
          const list = Array.isArray(res.data) ? res.data : [];
          contractCache.set(row.supplierId, list);
          applyListToRow(list);
        }
      });
    };

    // 初始化行的默认值（广告项目、联系人等）
    // forceLoadContract：是否强制根据供应商拉取并初始化联系人（用于上月自动带入）
    const initRowDefaults = (row, forceLoadContract = false) => {
      if (!row) return;
      if (!row.adProject) {
        row.adProject = contractTypeMap[row.contractType];
      }
      // 根据需要拉取联系人信息
      if (row.supplierId) {
        if (forceLoadContract) {
          loadContractForRow(row, true);
        } else if (!row.contractUserList || !row.contractUserList.length) {
          loadContractForRow(row, false);
        }
      }
    };

    // 用户手动勾选时
    const handleSelectionChange = selection => {
      // 之前已选中的合同编码集合
      const prevCodes = new Set(form.contractCodes);
      // 当前勾选的合同编码集合
      const newCodes = new Set(selection.map(row => row.contractCode));

      // 更新 contractCodes
      form.contractCodes.clear();
      newCodes.forEach(code => form.contractCodes.add(code));

      // 更新 selectMap
      form.selectMap.clear();
      selection.forEach(row => {
        form.selectMap.set(row.contractCode, row);
      });

      // 同步生成/维护计提行：保留仍然选中的合同的所有行
      const newRows = [];
      form.contractRows.forEach(item => {
        if (newCodes.has(item.contractCode)) {
          newRows.push(item);
        }
      });

      // 只为“新勾选的合同”补充至少一行，并初始化默认值
      newCodes.forEach(code => {
        const isNewAdded = !prevCodes.has(code);
        if (!isNewAdded) return;
        const hasRow = newRows.some(item => item.contractCode === code);
        if (!hasRow) {
          const baseRow = form.selectMap.get(code);
          if (baseRow) {
            initRowDefaults(baseRow, false);
            newRows.push(baseRow);
          }
        }
      });
      form.contractRows = newRows;
    };
    const handleRemove = row => {
      // 从计提行中删除当前行
      form.contractRows = form.contractRows.filter(item => item !== row);
      // 如果该合同已无任何行，则视为取消勾选
      const stillHasThisContract = form.contractRows.some(item => item.contractCode === row.contractCode);
      if (!stillHasThisContract) {
        form.contractCodes.delete(row.contractCode);
        form.selectMap.delete(row.contractCode);
        // 同步列表勾选状态
        nextTick(() => {
          setTableSelection();
        });
      }
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };

    /** 清空已选合同（不请求接口） */
    const clearContractSelection = () => {
      form.contractCodes.clear();
      form.selectMap.clear();
      form.contractRows = [];
    };

    // dialog 打开：添加计提任务时初始化表单并拉取上月合同；继续添加合同时不拉上月合同，仅清空勾选
    const handleOpened = () => {
      var _props$appendPreset;
      if (isAddMode.value) {
        form.date = dayjs().format('YYYY-MM');
        form.endDate = dayjs().add(1, 'month').format('YYYY-MM-DD');
        form.accrueProofTemplateUrls = '';
        flashSelect(form.date);
      } else if ((_props$appendPreset = props.appendPreset) !== null && _props$appendPreset !== void 0 && _props$appendPreset.month) {
        form.date = props.appendPreset.month;
        form.endDate = props.appendPreset.endDate || dayjs().add(1, 'month').format('YYYY-MM-DD');
        form.accrueProofTemplateUrls = props.appendPreset.accrueProofTemplateUrls || '';
        clearContractSelection();
      }
    };
    const flashSelect = month => {
      clearContractSelection();
      const targetMonth = month || form.date || dayjs().format('YYYY-MM');
      apis.nearestMonthContracts({
        month: targetMonth
      }).then(res => {
        if (!res.success || !res.data) return;
        form.accrueProofTemplateUrls = res.data.urls || '';
        const list = Array.isArray(res.data.list) ? res.data.list : [];
        list.forEach(row => {
          form.contractCodes.add(row.contractCode);
          form.selectMap.set(row.contractCode, row);
          // 上一个月自动带入的合同，强制拉取并初始化联系人
          initRowDefaults(row, true);
          form.contractRows.push(row);
        });
      });
    };
    const handleSelectOpened = () => {
      data.loading = true;
      loadData();
    };
    const parseProofTemplateFileList = urlString => {
      if (!urlString) return [];
      return String(urlString).split(',').map(item => item.trim()).filter(Boolean).map((url, index) => {
        const segments = url.split('/');
        const rawName = segments[segments.length - 1] || `文件${index + 1}`;
        return {
          id: `${Date.now()}-${index}-${rawName}`,
          fileUrl: url,
          fileName: decodeURIComponent(rawName)
        };
      });
    };
    const syncProofTemplateUrls = () => {
      form.accrueProofTemplateUrls = proofTemplateDialog.fileList.map(item => item.fileUrl).filter(Boolean).join(',');
    };
    const openProofTemplateDialog = () => {
      proofTemplateDialog.fileList = parseProofTemplateFileList(form.accrueProofTemplateUrls);
      proofTemplateDialog.visible = true;
    };
    const closeProofTemplateDialog = () => {
      proofTemplateDialog.visible = false;
    };
    const handleDeleteProofTemplate = row => {
      proofTemplateDialog.fileList = proofTemplateDialog.fileList.filter(item => item.id !== row.id);
      syncProofTemplateUrls();
    };
    const handlePreviewProofTemplate = row => {
      if (!(row !== null && row !== void 0 && row.fileUrl)) {
        ElMessage.warning('文件地址不存在');
        return;
      }
      apis.getFileEndPoint().then(res => {
        window.open(res.data + row.fileUrl);
      });
    };
    const handleUploadProofTemplateSuccess = files => {
      if (!files || files.length === 0) {
        ElMessage.warning('请先上传文件');
        return;
      }
      const newFiles = files.map((file, index) => ({
        id: file.id || `${Date.now()}-${index}-${file.fileName || '文件'}`,
        fileName: file.fileName || `文件${index + 1}`,
        fileUrl: file.relativeUrl || file.fileUrl || ''
      })).filter(item => item.fileUrl);
      if (newFiles.length === 0) {
        ElMessage.error('上传返回文件地址为空');
        return;
      }
      proofTemplateDialog.fileList.push(...newFiles);
      syncProofTemplateUrls();
      proofTemplateDialog.uploadVisible = false;
    };
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        width: "50%",
        title: dialogTitle.value,
        "model-value": __props.visible,
        onClose: close,
        onOpened: handleOpened,
        "close-on-press-escape": false,
        "append-to-body": "",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        class: "contract-select-dialog"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "formRef",
          model: form,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [isAddMode.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "计提月份"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: form.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.date = $event),
              type: "month",
              "value-format": "YYYY-MM",
              format: "YYYY-MM",
              placeholder: "选择计提月份",
              clearable: false,
              onChange: _cache[1] || (_cache[1] = $event => flashSelect(form.date))
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              style: {
                "margin-left": "30px"
              },
              onClick: openProofTemplateDialog
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("计提证明材料模板", -1)]))]),
              _: 1
            })]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "计提月份"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(form.date), 1)]),
            _: 1
          })), isAddMode.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "计提任务时效"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: form.endDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.endDate = $event),
              type: "date",
              "value-format": "YYYY-MM-DD",
              format: "YYYY-MM-DD",
              placeholder: "选择计提任务结束时间",
              clearable: false
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "勾选合同"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = $event => selectData.selectShow = true)
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("点击勾选", -1)]))]),
              _: 1
            })]),
            _: 1
          }), form.contractRows.length ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3,
            "label-width": "0",
            class: "contract-select-area"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: form.contractRows,
              style: {
                "width": "100%"
              },
              border: "",
              height: "600"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                prop: "contractCode",
                label: "合同编码",
                width: "180px"
              }), _createVNode(_component_el_table_column, {
                prop: "contractName",
                label: "合同名称"
              }), _createVNode(_component_el_table_column, {
                prop: "adProject",
                label: "广告项目",
                width: "180px"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_input, {
                  modelValue: scope.row.adProject,
                  "onUpdate:modelValue": $event => scope.row.adProject = $event
                }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "supplier",
                label: "供应商",
                width: "220px"
              }), _createVNode(_component_el_table_column, {
                label: "供应商联系人",
                width: "200px"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_select, {
                  modelValue: scope.row.contractUserMobile,
                  "onUpdate:modelValue": $event => scope.row.contractUserMobile = $event,
                  placeholder: "请选择联系人",
                  style: {
                    "width": "150px"
                  },
                  onChange: val => {
                    const user = (scope.row.contractUserList || []).find(item => item.mobile === val);
                    if (user) {
                      scope.row.contractUserId = user.userId;
                      scope.row.contractUserName = user.name;
                      scope.row.contractUserMobile = user.mobile;
                    }
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.contractUserList || [], item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.mobile,
                      label: item.name + '（' + item.mobile + '）',
                      value: item.mobile
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "contractAmount",
                label: "合同金额",
                width: "100px"
              }), _createVNode(_component_el_table_column, {
                prop: "endDate",
                label: "合同失效时间",
                width: "120px"
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "140"
              }, {
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: () => {
                    const copyRow = JSON.parse(JSON.stringify(scope.row));
                    form.contractRows.splice(form.contractRows.indexOf(scope.row) + 1, 0, copyRow);
                  }
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("复制", -1)]))]),
                  _: 1
                }, 8, ["onClick"]), _createVNode(_component_el_button, {
                  link: "",
                  type: "danger",
                  size: "small",
                  onClick: $event => handleRemove(scope.row)
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("删除", -1)]))]),
                  _: 1
                }, 8, ["onClick"])])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            "label-width": "0",
            class: "contract-select-area"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: handleCommit,
              style: {
                "margin-top": "10px"
              }
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("提交", -1)]))]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: close,
              style: {
                "margin-top": "10px"
              }
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("取消", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "model-value"]), _createVNode(_component_el_dialog, {
        title: "选择合同",
        modelValue: selectData.selectShow,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => selectData.selectShow = $event),
        width: "50%",
        onOpened: handleSelectOpened
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "合同编码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.queryParam.contractCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.queryParam.contractCode = $event),
              placeholder: "请输入合同编码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.queryParam.contractName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.queryParam.contractName = $event),
              placeholder: "请输入合同名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "供应商"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: data.queryParam.supplier,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.queryParam.supplier = $event),
              placeholder: "请输入供应商"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "合同生效时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: data.queryParam.validDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.queryParam.validDate = $event),
              type: "date",
              placeholder: "合同在该时间是否生效",
              "value-format": "YYYY-MM-DD",
              style: {
                "width": "150px"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: _unref(Search),
              plain: "",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("查询", -1)]))]),
              _: 1
            }, 8, ["icon"]), _createVNode(_component_el_button, {
              onClick: handleReset,
              style: {
                "margin-left": "5px"
              }
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref_key: "tableRef",
          ref: tableRef,
          style: {
            "width": "100%"
          },
          data: data.tableData,
          height: "650",
          "row-key": "contractCode",
          onSelect: handleSelectionChange,
          onSelectAll: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "50"
          }), _createVNode(_component_el_table_column, {
            prop: "contractCode",
            label: "合同编码",
            width: "180px"
          }), _createVNode(_component_el_table_column, {
            prop: "contractName",
            label: "合同名称"
          }), _createVNode(_component_el_table_column, {
            prop: "supplier",
            label: "供应商",
            width: "250px"
          }), _createVNode(_component_el_table_column, {
            prop: "contractAmount",
            label: "合同金额",
            width: "100px"
          }), _createVNode(_component_el_table_column, {
            prop: "endDate",
            label: "合同失效时间",
            width: "120px"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, data.loading]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "page-sizes": [10, 20, 50, 100, 200],
          "page-size": data.pagination.pageSize,
          total: data.pagination.totalSize,
          currentPage: data.pagination.pageNo,
          "onUpdate:currentPage": _cache[8] || (_cache[8] = $event => data.pagination.pageNo = $event),
          layout: "total, prev, pager, next, sizes, jumper",
          style: {
            "margin-top": "5px"
          }
        }, null, 8, ["page-size", "total", "currentPage"])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: proofTemplateDialog.visible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => proofTemplateDialog.visible = $event),
        title: "计提证明材料模板",
        width: "700px",
        "append-to-body": "",
        onClose: closeProofTemplateDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: closeProofTemplateDialog
        }, {
          default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("关闭", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => proofTemplateDialog.uploadVisible = true)
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("上传文件", -1)]))]),
          _: 1
        })]), _createVNode(_component_el_table, {
          data: proofTemplateDialog.fileList,
          border: "",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "fileName",
            label: "文件名",
            "min-width": "420"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: $event => handlePreviewProofTemplate(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("预览", -1)]))]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              link: "",
              type: "danger",
              size: "small",
              onClick: $event => handleDeleteProofTemplate(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("删除", -1)]))]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(MoreUpload, {
        visible: proofTemplateDialog.uploadVisible,
        "onUpdate:visible": _cache[12] || (_cache[12] = $event => proofTemplateDialog.uploadVisible = $event),
        title: "上传计提证明材料模板",
        multiple: true,
        buckets: 'outer-for-inner',
        onUploadSuccess: handleUploadProofTemplateSuccess
      }, null, 8, ["visible"])], 64);
    };
  }
};